<div autofocus tabindex="0" id="menu-profile-container">
    <nav (keyup.escape)="close()" aria-label="Profile Menu">
        <div id="account-settings-header">
            <i class="fa-regular fa-user" [style.color]="'#fff'"></i>
            <p>{{ 'toolbar.profilePanel.header' | translate }}</p>
        </div>

        <ng-container [ngTemplateOutlet]="menuProfile"> </ng-container>
    </nav>
</div>

<ng-template #menuProfile>
    <ul id="menu-profile">
        <li id="account-settings-item">
            <a
                [href]="accountSettingsUrl"
                target="_blank"
                id="account-settings-link"
                aria-label="Go to Account Settings">
                <button id="account-settings" tabindex="-1">
                    <div class="item-container">
                        <div class="btn-icon" id="account-settings-icon" aria-hidden="true">
                            <i class="fa-light fa-user-gear"></i>
                        </div>
                        <label for="account-settings-icon" id="account-settings-label">{{
                            'profileMenu.accountSettings' | translate
                        }}</label>
                    </div>
                    <i class="fa-regular fa-arrow-up-right-from-square"></i>
                </button>
            </a>
        </li>

        <li id="sign-out-item">
            <button id="sign-out-link" (click)="logout()">
                <div class="btn-icon" id="sign-out-icon" aria-hidden="true">
                    <i class="fa-light fa-right-from-bracket"></i>
                </div>
                <label for="sign-out-icon" id="sign-out-label">{{ 'profileMenu.signOut' | translate }}</label>
            </button>
        </li>
    </ul>
</ng-template>
